import { ArrowsClockwiseIcon } from "@phosphor-icons/react/ArrowsClockwise";
import { PlusIcon } from "@phosphor-icons/react/Plus";
import { CustomsDocsUploadMode } from "@/Apis/CustomsDocsUploadMode";
import type { UpdateCustomsDocsStageProps } from "@/Shared/CustomDocs/Dialogs/CustomDocsUpdateDialog";
import { CustomDocsUpdateStageType } from "@/Shared/CustomDocs/Types/CustomDocsUpdateStageType";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { ChoiceCards } from "@freightsimple/ui-core/Controls/ChoiceCards";
import { Icon } from "@freightsimple/ui-core/Icons/Icon";
import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";

export function CustomDocsUpdateSelectModeStage({
  setMode,
  onDone,
  setStage,
  mode,
}: UpdateCustomsDocsStageProps) {
  function handleNextClick() {
    if (mode === undefined) {
      return;
    }

    setStage(CustomDocsUpdateStageType.SUBMIT);
  }

  return (
    <Stack gap={6}>
      <Heading level={3}>Do you want to replace or add documents?</Heading>
      <ChoiceCards
        value={mode}
        onChange={(value) =>
          setMode(
            value === CustomsDocsUploadMode.Replace
              ? CustomsDocsUploadMode.Replace
              : CustomsDocsUploadMode.Add,
          )
        }
        options={[
          {
            value: CustomsDocsUploadMode.Replace,
            content: (
              <Row gap={6}>
                <Icon icon={ArrowsClockwiseIcon} size="3xl" weight="fill" />
                <Stack gap={1}>
                  <T weight="medium">Replace</T>
                  <T color="secondary">
                    Replace existing documents with new ones. All current
                    documents will be deleted and replaced.
                  </T>
                </Stack>
              </Row>
            ),
          },
          {
            value: CustomsDocsUploadMode.Add,
            content: (
              <Row gap={6}>
                <Icon icon={PlusIcon} size="3xl" weight="fill" />
                <Stack gap={1}>
                  <T weight="medium">Add</T>
                  <T color="secondary">
                    Keep existing documents and add new ones without removing or
                    altering any current documents.
                  </T>
                </Stack>
              </Row>
            ),
          },
        ]}
      />
      <Row justify="end" gap={3} wrap>
        <Button onClick={onDone}>Cancel</Button>
        <Button
          primary
          onClick={handleNextClick}
          disabled={mode === undefined}
          disabledMessage="Choose Replace or Add to continue"
        >
          Next
        </Button>
      </Row>
    </Stack>
  );
}
